export const DRAWER_LAYOUT_LABELS = {
  commentPlaceholder: 'Add a comment',
  addCommentAriaLabel: 'Add comment',
} as const
